import { handleActions } from "redux-actions";
import { fromJS, Map } from "immutable";
import {
    CAMPAIGN_RECIPIENTS_FETCH_FAILURE,
    CAMPAIGN_RECIPIENTS_FETCH_START,
    CAMPAIGN_RECIPIENTS_FETCH_SUCCESS,
    CAMPAIGN_RECIPIENTS_FILTER_CHANGE,
    CAMPAIGN_RECIPIENTS_SEARCH_CHANGE,
    CAMPAIGN_RECIPIENTS_SORT_CHANGE,
    CAMPAIGN_RESET,
} from "constants/action-types";

const initialState = {
    result: [],
    isFetching: false,
    nextPage: undefined,
    error: undefined,
    errorMessage: "",
    filters: Map(),
    activeTab: "all",
    __sort: "company_name",
    __sort_order: "desc",
};

const campaignRecipientsReducer = handleActions(
    {
        [CAMPAIGN_RECIPIENTS_FETCH_START]: (state) => {
            return Object.assign({}, state, {
                isFetching: true,
                nextPage: undefined,
            });
        },
        [CAMPAIGN_RECIPIENTS_FETCH_SUCCESS]: (state, { payload, meta = {} }: any) => {
            let result;
            if (meta && meta.replace) {
                result = payload;
            } else {
                result = state.result.concat(payload);
            }

            return Object.assign({}, state, {
                result: result,
                isFetching: false,
                nextPage: meta.nextPage,
            });
        },
        [CAMPAIGN_RECIPIENTS_FETCH_FAILURE]: (state, { payload, error }) => {
            return Object.assign({}, state, {
                isFetching: false,
                error: error ? payload : undefined,
            });
        },
        [CAMPAIGN_RECIPIENTS_FILTER_CHANGE]: (state, { payload }) => {
            const newFilters = fromJS(payload.filters);
            return Object.assign({}, state, {
                filters: newFilters,
                result: [],
            });
        },
        [CAMPAIGN_RECIPIENTS_SORT_CHANGE]: (state, { payload }) => {
            const { __sort, __sort_order } = payload;
            return Object.assign({}, state, {
                __sort,
                __sort_order,
                result: [],
            });
        },
        [CAMPAIGN_RECIPIENTS_SEARCH_CHANGE]: (state, { payload }) => {
            return Object.assign({}, state, {
                __search: payload.__search,
                result: [],
            });
        },
        [CAMPAIGN_RESET]: (): Object => {
            return initialState;
        },
    } as any,
    initialState
);

export default campaignRecipientsReducer;
